import { useQuery } from "@tanstack/react-query";
import * as AgenticV2API from "@/services/api/agentic-v2";
import { useCompanyId } from "@/context/CompanyContext";
import { useWindowLive } from "@/components/ui/os-layout/WindowActiveContext";
import { clientsKeys } from "./keys";

export interface UseClientTimelineOptions {
  faClientId: string;
  enabled?: boolean;
}

/** Unified events + memories timeline for one fa_client. */
export function useClientTimeline({
  faClientId,
  enabled: enabledOption = true,
}: UseClientTimelineOptions) {
  const isWindowLive = useWindowLive();
  const companyId = useCompanyId();
  const queryEnabled = Boolean(faClientId) && enabledOption && isWindowLive;

  const query = useQuery({
    queryKey: clientsKeys.timeline(faClientId, companyId ?? undefined),
    enabled: queryEnabled,
    refetchOnWindowFocus: queryEnabled,
    queryFn: () => AgenticV2API.listClientTimeline(faClientId, { limit: 50 }),
  });

  return {
    entries: query.data ?? [],
    loading: query.isLoading,
    error: query.error,
    refresh: () => void query.refetch(),
  };
}
